import * as React from 'react';
import { ClearDiv } from '../';

export class ColFull extends React.PureComponent<React.PropsWithChildren<{ id?: string }>> {
	public render() {
		return (
			<ClearDiv className='row' {...this.props}>
				<div className='col-lg-12 col-sm-12'>{this.props.children}</div>
			</ClearDiv>
		);
	}
}
